"use strict";
/*
 * indicative-parser
 *
 * (c) Harminder Virk <virk@adonisjs.com>
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
*/
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Parses a schema and returns it's parsed tree along with a
 * superficial object to be used as types.
 */
function schema(definedSchema) {
    return Object.keys(definedSchema).reduce((result, key) => {
        result.schema[key] = definedSchema[key].getTree();
        return result;
    }, { schema: {} });
}
exports.schema = schema;
